export default __webpack_public_path__ + "static/color-psychology-16eaa3822a521ab117d67d909cab7fbd.png";